/**
 * Project View, Volt Route Definition.
 *
 * Static metadata describing the project view route.
 * No imports of view code. Can be statically extracted by FactsMap.
 *
 * When Volt Controllers land, a Controller replaces this file entirely.
 */

import type { RouteDefinition } from '@townsquare/router/volt/types';

const _default_1: {
	name: string;
	pattern: string;
	scope: 'site';
	app: 'projects';
	entrypoint: string;
	// Controller concerns. Moves to server when Controllers land.
	capabilities: 'projects_app:access'[];
	enableRestrictedFallback: true;
	subproduct: 'townsquare-projects';
} = {
	name: 'channel',
	pattern: '/project/:id/:tabName?/:resourceId?',
	scope: 'site',
	app: 'projects',
	entrypoint: 'ProjectPageEntrypoint',

	// Controller concerns. Moves to server when Controllers land.
	capabilities: ['projects_app:access'],
	enableRestrictedFallback: true,
	subproduct: 'townsquare-projects',
} satisfies RouteDefinition;
export default _default_1;
